export default __webpack_public_path__ + "static/media/home-dentist-icon-06.e4f90c65.svg";